export const CrewRoutes = {
	Dashboard: `/`,
	Dtf: {
		Landing: `/dtf`,
	},
	Embroidery: {
		Landing: `/embroidery`,
		ApproveMerch: (id: string) => `/embroidery/${id}`,
	},
	ScreenPrinting: {
		Landing: `/screen-printing`,
		ApproveMerch: (id: string) => `/screen-printing/${id}`,
	},
	Orders: {
		Landing: `/orders`,
		View: (id: string) => ({
			Landing: `/orders/${id}`,
			Edit: `/orders/${id}/edit`,
			LineItem: (lineItemId: string) => ({
				Landing: `/orders/${id}/${lineItemId}`,
				Edit: `/orders/${id}/${lineItemId}/edit`,
				Sizes: `/orders/${id}/${lineItemId}/sizes`,
				Breakdown: `/orders/${id}/${lineItemId}/breakdown`,
			}),
			Add: `/orders/${id}/add`,
			Designs: `/orders/${id}/designs`,
			RefundReceipt: (refundId: string) => `/orders/${id}/refund/${refundId}.pdf`,
		}),
	},
	Quotes: {
		Landing: `/quotes`,
		InitiateQuote: `/quotes/initiate-quote`,
		DeleteActiveQuote: `/quotes/delete-active`,
		View: (id: string | number) => `/quotes/${id}`,
		EmailCustomer: (id: string | number, email?: string) => `/quotes/${id}/generate-cart${email ? `?email=${email}` : ''}`,
	},
	Products: {
		Landing: `/products`,
		Export: `/products/export.xlsx`,
		View: (id: string) => ({
			Landing: `/products/${id}`,
			Edit: `/products/${id}/edit`,
			Colours: {
				Add: `/products/${id}/colours/add`,
				Edit: (colourId: string) => `/products/${id}/colours/${colourId}/edit`,
			},
			Areas: {
				Add: (side?: string) => (side ? `/products/${id}/area/add?side=${side}` : `/products/${id}/area/add`),
				View: (side: string) => `/products/${id}/area/${side}`,
			},
		}),
		Add: `/products/add`,
	},
	Customers: {
		Landing: `/customers`,
		View: (id: string) => ({
			Landing: `/customers/${id}`,
			Edit: `/customers/${id}/edit`,
			Orders: `/customers/${id}/orders`,
			Address: (addressId: string) => `/customers/${id}/address/${addressId}`,
		}),
	},
	Stores: {
		Landing: `/stores`,
		View: (id: string) => ({
			Landing: `/stores/${id}`,
			Edit: `/stores/${id}/edit`,
			Address: (addressId: string) => `/stores/${id}/address/${addressId}`,
			Orders: `/stores/${id}/orders`,
			Pricing: `/stores/${id}/pricing`,
			AddSpecialProduct: `/stores/${id}/add-special-product`,
		}),
	},
	Exports: {
		Landing: `/exports`,
		File: `/exports/file.xlsx`,
	},
	Coupons: {
		Landing: `/coupons`,
		Add: `/coupons/add`,
		View: (id: string) => ({
			Landing: `/coupons/${id}`,
			Edit: `/coupons/${id}/edit`,
		}),
	},
	Statistics: `/statistics`,
	//Warehouse apps
	Labelling: '/labelling',
	Inventory: {
		Landing: `/inventory`,
		Product: (id: string) => `/inventory/${id}`,
	},
	Printing: '/printing',
	Shipping: '/shipping',
	API: {
		Users: (query: string) => '/api/users?search=' + query,
		Products: {
			Search: '/api/products/search',
		},
	},
} as const;
